module.exports = "/images/gotham-18.jpg";